import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row } from 'react-bootstrap';
import MenuTabs from './MenuTabs';

const Adress = () =>{
  return (
    <div>Address</div>
  )
};

const tabsData = [
  {
    name: 'Address',
    content: <Adress />,
    icon: <FontAwesomeIcon icon={light('map-location-dot')} />,
    href: '#/profile/address'
  },
  {
    name: 'Email',
    content: <div>Email</div>,
    icon: <FontAwesomeIcon icon={light('at')} />,
    href: '#/profile/email'
  },
  {
    name: 'Phone',
    content: <div>Phone</div>,
    icon: <FontAwesomeIcon icon={light('phone')} />,
    href: '#/profile/phone'
  },
  {
    name: 'Communication',
    content: <div>Communication</div>,
    icon: <FontAwesomeIcon icon={light('bullhorn')} />,
    href: '#/profile/communication'
  },
  {
    name: 'Banking',
    content: <div>Banking</div>,
    icon: <FontAwesomeIcon icon={light('bank')} />,
    href: '#/profile/banking'
  },
  {
    name: 'Beneficiaries',
    content: <div>Beneficiaries</div>,
    icon: <FontAwesomeIcon icon={light('family')} />,
    href: '#/profile/beneficiaries'
  },
  {
    name: 'Family Members',
    content: <div>Family Members</div>,
    icon: <FontAwesomeIcon icon={light('family')} />,
    href: '#/profile/familymembers'
  },
  {
    name: 'Login & Recovery',
    content: <div>Login & Recovery</div>,
    icon: <FontAwesomeIcon icon={light('lock-open')} />,
    href: '#/profile/login'
  },
];

const MenuTabsDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Menu Tabs Component</h4>
        <Row>
          <MenuTabs tabs={tabsData} />
        </Row>
      </Container>
    </Container>
  );
};

export default MenuTabsDemo;
